import React, { useEffect, useRef, useState } from 'react';
import {
    Alert,
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    Typography
} from '@mui/material';
import AgentPolicyContent from './AgentPolicyContent';

export default function AgentPolicyGateDialog({ policyGate }) {
    const contentRef = useRef(null);
    const [scrolled, setScrolled] = useState(false);
    const [checked, setChecked] = useState(false);
    const { status, requiresAcknowledgement, acknowledging, error, acknowledge } = policyGate;

    useEffect(() => {
        setChecked(false);
        setScrolled(false);
        if (!requiresAcknowledgement) return undefined;
        const timer = setTimeout(() => {
            const node = contentRef.current;
            if (node && node.scrollHeight <= node.clientHeight + 8) {
                setScrolled(true);
            }
        }, 50);
        return () => clearTimeout(timer);
    }, [requiresAcknowledgement, status?.activePolicy?.version]);

    const handleScroll = (event) => {
        const node = event.currentTarget;
        if (node.scrollTop + node.clientHeight >= node.scrollHeight - 8) {
            setScrolled(true);
        }
    };

    const handleAcknowledge = async () => {
        if (await acknowledge()) {
            setChecked(false);
            setScrolled(false);
        }
    };

    return (
        <Dialog open={requiresAcknowledgement} maxWidth="md" fullWidth disableEscapeKeyDown onClose={() => {}}>
            <DialogTitle>{status?.activePolicy?.title || 'Company Policy & Work Rules'}</DialogTitle>
            <DialogContent dividers ref={contentRef} onScroll={handleScroll} sx={{ maxHeight: '62vh' }}>
                <Alert severity="info" sx={{ mb: 2 }}>
                    Please read the full policy, scroll to the bottom, then check the acknowledgement box.
                </Alert>
                <AgentPolicyContent html={status?.activePolicy?.html || ''} />
            </DialogContent>
            <DialogActions sx={{ alignItems: 'stretch', flexDirection: 'column', gap: 1.5, p: 2 }}>
                {!scrolled && (
                    <Typography variant="caption" color="text.secondary">
                        Scroll to the bottom of the policy to enable acknowledgement.
                    </Typography>
                )}
                <FormControlLabel
                    control={(
                        <Checkbox
                            checked={checked}
                            disabled={!scrolled || acknowledging}
                            onChange={(event) => setChecked(event.target.checked)}
                        />
                    )}
                    label="I have read and understand the company policy and work rules."
                />
                {error && <Alert severity="error">{error}</Alert>}
                <Box display="flex" justifyContent="flex-end">
                    <Button
                        variant="contained"
                        disabled={!scrolled || !checked || acknowledging}
                        onClick={handleAcknowledge}
                    >
                        {acknowledging ? 'Saving...' : 'Acknowledge Policy'}
                    </Button>
                </Box>
            </DialogActions>
        </Dialog>
    );
}
